import React from 'react';
import PropTypes from 'prop-types';
import { Input, InputGroup, InputGroupAddon, InputGroupText, Button } from 'reactstrap';

import './PesquisaRapida.scss';

function PesquisaRapida(props) {

	const {
		rawData, 
		rawDocs, 
		// rawDocsValorTotal, 
		rawDocsReceita, 
		rawDocsDestinatario, 
		// rawDocsVlPrincipal
	} = props;

	var showLista = [];
	var showListaReceita = [];
	var showListaDestinatario = [];
	
	const pesquisaRapida = (value, blShow) => {
		//console.log(JSON.stringify(value));
		if (value) {
			
			/** Filtro apenas do retorno do numero do documento */
			const showDocs = rawDocs.filter(item => {
				return Object.keys(item).some(
					x => typeof item === 'string' && x !== "data" && item.toLowerCase().includes(value.toLowerCase())
				);
			});

			/** Filtro retorno valor principal lista documento fiscal 
			 * Esse já funciona pelo filtro showData
			*/
			// const showDocsVlPrincipal = rawDocsVlPrincipal.filter(item => {
			// 	return item.toString().includes(value);
			// });
			
			/** Filtro retorno valor total lista documento fiscal 
			 * Esse já é mostrado pelo filtro showData
			*/
			// const showDocsValorTotal = rawDocsValorTotal.filter(item => {
			// 	return item.toString().includes(value.replace('.', '').replace(',', '.'));
			// });
			
			/** Filtro retorno receita lista documento fiscal */
			const showDocsReceita = rawDocsReceita.filter(item => {
				return Object.keys(item).some(
					x => typeof item === 'string' && item.toLowerCase().includes(value.toLowerCase())
				);
			});

			/** Filtro retorno destinatario lista documento fiscal */
			const showDocsDestinatario = rawDocsDestinatario.filter(item => {
				return Object.keys(item).some(
					x => typeof item === 'string' && item.toLowerCase().includes(value.toLowerCase())
				);
			});

			const showData = props.rawData.filter(item => {
				return Object.keys(item).some(
					x => x !== "id" &&
						x !== "idEmpresa" &&
						x !== "ipUsuario" &&
						x !== "blGnreErro" &&
						x !== "blSelected" &&
						((x === "data" && item[x] !== "" && (new Date(item[x]).toLocaleDateString()).includes(value)) ||
						(typeof item[x] === 'number' && item[x].toString().includes(value.replace('.', '').replace(',', '.'))) ||
						(typeof item[x] === 'string' && x !== "data" && item[x].toLowerCase().includes(value.toLowerCase())))					
				);
			});
			
			if (showDocs.length > 0) {
				var retornar = false;
				rawData.forEach(ele => {
					retornar = false;
					ele.listDocumentosFiscais.forEach(el => {						
						showDocs.forEach(e => {
							if (el.strDocumento === e && !retornar) {
								showLista.push(ele);
								retornar = true;
							}
						});
					});
				});
			}

			if (showDocsReceita.length > 0) {
				var retornar = false;
				rawData.forEach(elem => {
					retornar = false;
					elem.listDocumentosFiscais.forEach(el => {
						showDocsReceita.forEach(e => {
							if (el.strReceita == e && !retornar) {
								showListaReceita.push(elem);
								retornar = true;
							}
						});
					});
				});
			}
			
			if (showDocsDestinatario.length > 0) {
				var retornar = false;
				rawData.forEach(elem => {
					retornar = false;
					elem.listDocumentosFiscais.forEach(el => {
						showDocsDestinatario.forEach(e => {
							if (el.strDestinatario == e && !retornar) {
								showListaDestinatario.push(elem);
								retornar = true;
							}
						});
					});
				});
			}

			const showAllData = [...showLista, ...showListaReceita, ...showListaDestinatario, ...showData];

			props.onUpdate(showAllData, value, blShow);
			
		} else {
			props.onUpdate(props.rawData, value, blShow);
		}
	};

	const handleClose = () => {
		setImmediate(() => pesquisaRapida(''));
	};

	return (
		<InputGroup onMouseLeave={props.onMouseLeave} onClick={props.onClick} onBlur={props.onBlur}>
			<InputGroupAddon addonType="prepend">
				<InputGroupText>
					<i className="fas fa-search" />
				</InputGroupText>
			</InputGroupAddon>
			<Input 
				value={props.value} 
				type="text" 
				onChange={({ target: { value } }) => pesquisaRapida(value, true)} 
				placeholder="Emitente, Vlr Total, Doc, Dest, Receita, Vlr Principal..."
			/>
			<InputGroupAddon addonType="append">
				<Button color="info" className="btn-pesquisa" onClick={handleClose}>
					<i className="fas fa-times" />
				</Button>
			</InputGroupAddon>
		</InputGroup>
	);
}

PesquisaRapida.propTypes = {
	onBlur: PropTypes.func.isRequired,
	onClick: PropTypes.func.isRequired,
	onMouseLeave: PropTypes.func.isRequired,
	onUpdate: PropTypes.func.isRequired,
	rawData: PropTypes.array,
	value: PropTypes.string.isRequired,
};

export default PesquisaRapida;
